import { sizeClasses } from "../../constants";
import { IconProps } from "../../types";
const SvgList = ({ size = "regular", className = "", ...props }: IconProps) => {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      fill="none"
      viewBox="0 0 24 24"
      className={`${sizeClasses[size]} ${className}`}
      {...props}
    >
      <path
        fill="currentColor"
        d="M3.69 3C2.757 3 2 3.806 2 4.8s.757 1.8 1.69 1.8c.934 0 1.69-.806 1.69-1.8S4.624 3 3.69 3M8.76 3.9c-.466 0-.845.403-.845.9s.379.9.846.9h12.394c.467 0 .845-.403.845-.9s-.378-.9-.845-.9zM3.69 10.2C2.757 10.2 2 11.006 2 12s.757 1.8 1.69 1.8c.934 0 1.69-.806 1.69-1.8s-.756-1.8-1.69-1.8M8.76 11.1c-.466 0-.845.403-.845.9s.379.9.846.9h12.394c.467 0 .845-.403.845-.9s-.378-.9-.845-.9zM3.69 17.4c-.933 0-1.69.806-1.69 1.8S2.757 21 3.69 21c.934 0 1.69-.806 1.69-1.8s-.756-1.8-1.69-1.8M8.76 18.3c-.466 0-.845.403-.845.9s.379.9.846.9h12.394c.467 0 .845-.403.845-.9s-.378-.9-.845-.9z"
      />
    </svg>
  );
};
export default SvgList;
